import React from "react";

import SendFeedbackButton from "./SendFeedbackButton";
import StorySheet from "./StorySheet";

const HOW_IT_WORKS = [
  { label: "Reading", description: "Click a sentence to see its translation and more options." },
  { label: "Fill in the blanks", description: "Click a box and pick the missing word." },
  { label: "Word translations", description: "Double-click a word, or press and hold it on a phone, to see what it means. You can also highlight a phrase. Click Save to learn to practice it later." },
  { label: "Audio player", description: "Listen to the story read out loud. Turn it on or off with Show audio player in the settings." },
  { label: "Settings", description: "Click the gear to change the Learning mode, mark the story as completed or reset it." }
];

export default function StoryInfoSheet({ onClose, onSendFeedback }) {
  return (
    <StorySheet testId="story-info-sheet" title="How it works" onClose={onClose}>
      {HOW_IT_WORKS.map(({ description, label }) => (
        <div className="story-info-item" key={label}>
          <strong>{label}</strong>
          <p>{description}</p>
        </div>
      ))}
      <SendFeedbackButton onClick={onSendFeedback} />
    </StorySheet>
  );
}
